import Axios from 'axios';

export const submit = async (formId: string, values) => {
  const { data } = await Axios.post(`/api/wufoo/entries?id=${formId}`, values);

  return data;
};
